export default __webpack_public_path__ + "571951a6d0fc093e9cd40c938e4919cc.png";